import { bodyFixed, bodyStatic } from '../helpers/helper.js';

export default class Nav {
  constructor() {
    this.navTrigger = document.getElementById('js-nav_trigger');
    this.navTarget = document.querySelectorAll('.js-nav_target');
    
    if(this.navTrigger && this.navTarget.length !== 0) {
      this.activeClass = 'is-active';
      this.touchedClass = 'is-touched';
      this.navFlag = false;

      this.init();
    }
  }

  init() {
    this.navTrigger.addEventListener('click', () => {
      this.navTrigger.classList.add(this.touchedClass);
      if(this.navFlag) {
        this.navClose();
      } else {
        this.navOpen();
      }
    });
  }

  navOpen() {
    this.navTrigger.classList.add(this.activeClass);
    this.navTarget.forEach(el => {
      el.classList.add(this.activeClass);
    });

    bodyFixed();
    this.navFlag = true;
  }

  navClose() {
    this.navTrigger.classList.remove(this.activeClass);
    this.navTarget.forEach(el => {
      el.classList.remove(this.activeClass);
    });

    bodyStatic();
    this.navFlag = false;
  }
}